<app-modal-layout>
  <h1 class="text-center">
    <strong>
      <ng-container>{{title}}</ng-container>
    </strong>
  </h1>
  <app-import-users (dataEvent)="receiveDataFromChild($event)"></app-import-users>
</app-modal-layout>
